import React, { useState, useEffect } from 'react';
import { Menu, X, ShoppingBag, Search } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const isHome = location.pathname === '/';

    return (
        <nav className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'glass py-4' : 'bg-transparent py-6'}`}>
            <div className="container mx-auto px-4 md:px-8 flex justify-between items-center">
                {/* Logo */}
                <Link to="/" className="text-2xl font-serif font-bold tracking-widest text-luxury-black">
                    ALIGN
                </Link>

                {/* Desktop Menu */}
                <div className="hidden md:flex items-center space-x-8">
                    <Link to="/" className="text-sm uppercase tracking-wide text-luxury-black hover:text-luxury-gold transition-colors">
                        Home
                    </Link>
                    <Link to="/collections" className="text-sm uppercase tracking-wide text-luxury-black hover:text-luxury-gold transition-colors">
                        Collections
                    </Link>
                    <a href="#brands" className="text-sm uppercase tracking-wide text-luxury-black hover:text-luxury-gold transition-colors">
                        Brands
                    </a>
                    <a href="#about" className="text-sm uppercase tracking-wide text-luxury-black hover:text-luxury-gold transition-colors">
                        About
                    </a>
                </div>

                {/* Icons */}
                <div className="hidden md:flex items-center space-x-6 text-luxury-black">
                    <Search className="w-5 h-5 cursor-pointer hover:text-luxury-gold transition-colors" />
                    <ShoppingBag className="w-5 h-5 cursor-pointer hover:text-luxury-gold transition-colors" />
                </div>

                {/* Mobile Menu Button */}
                <div className="md:hidden">
                    <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-luxury-black">
                        {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
                    </button>
                </div>
            </div>

            {/* Mobile Menu Overlay */}
            {isMobileMenuOpen && (
                <div className="absolute top-full left-0 w-full glass border-t border-white/10 flex flex-col items-center py-8 space-y-6 md:hidden">
                    <Link
                        to="/"
                        className="text-lg uppercase tracking-wide text-luxury-black hover:text-luxury-gold transition-colors"
                        onClick={() => setIsMobileMenuOpen(false)}
                    >
                        Home
                    </Link>
                    <Link
                        to="/collections"
                        className="text-lg uppercase tracking-wide text-luxury-black hover:text-luxury-gold transition-colors"
                        onClick={() => setIsMobileMenuOpen(false)}
                    >
                        Collections
                    </Link>
                    <a
                        href="#brands"
                        className="text-lg uppercase tracking-wide text-luxury-black hover:text-luxury-gold transition-colors"
                        onClick={() => setIsMobileMenuOpen(false)}
                    >
                        Brands
                    </a>
                    <a
                        href="#about"
                        className="text-lg uppercase tracking-wide text-luxury-black hover:text-luxury-gold transition-colors"
                        onClick={() => setIsMobileMenuOpen(false)}
                    >
                        About
                    </a>
                </div>
            )}
        </nav>
    );
};

export default Navbar;
